/* @flow */
import Button from 'components/Button.jsx';
import ClipboardTrigger from 'components/ClipboardTrigger.jsx';
import FormSingle from 'components/FormSingle.jsx';
import Glyph from 'components/Glyph.jsx';
import Image from 'components/Image.jsx';
import Input from 'components/Input.jsx';
import LinkConstants from 'constants/LinkConstants';
import React from 'react';
import ShareRemindSocial from 'user/components/ShareRemindSocial.jsx';
import ToastActions from 'actions/ToastActions';
import User from 'entities/User';
import { Roles } from 'user/UserConstants';

import './styles/ShareRemind.scss';

class ShareRemind extends React.Component {
  static propTypes = {
    user: React.PropTypes.instanceOf(User),
  };

  showCopyToast = () => {
    ToastActions.showSuccessToast(
      'URL has been copied to your clipboard'
    );
  };

  render() {
    let shareByEmailButton;
    let socials;

    if (this.props.user) {
      shareByEmailButton = (
        <ShareRemindSocial medium="email" user={this.props.user}>
          <Button full size="small">
            <Glyph name="email" size="medium" />
            Share by email
          </Button>
        </ShareRemindSocial>
      );
      socials = ['facebook', 'twitter', 'pinterest'].map((name, index) => {
        return (
          <ShareRemindSocial
            key={index}
            medium={name}
            className="ShareRemind-socialLink"
            user={this.props.user}>
            <Glyph className="ShareRemind-socialIcon" name={name} color={name} size="xlarge" solo />
          </ShareRemindSocial>
        );
      });
    }

    const url = this.props.user ?
      this.props.user.getReferralUrl() :
      LinkConstants.MARKETING;

    const shareText = this.props.user ?
      <p>Or share us on</p> : '';

    let subtext;
    if (this.props.user && (this.props.user.getRole() !== Roles.teacher)) {
      subtext = 'Spread the word and share us with teachers at your school.';
    } else {
      subtext = 'Spread the word and share us with colleagues at your school.';
    }

    return (
      <div className="ShareRemind">
        <div className="ShareRemind-header">
          <Image src={require('assets/images/love-remind.svg')} />
          <h3>Love Remind?</h3>
          <p>{subtext}</p>
        </div>
        <FormSingle className="ShareRemind-referralUrl" reset="mobile">
          <Input className="ShareRemind-input" value={url} readOnly />
          <ClipboardTrigger text={url} onCopy={this.showCopyToast}>
            <Button level="secondary" size="small">
              Copy link
            </Button>
          </ClipboardTrigger>
        </FormSingle>
        {shareByEmailButton}
        <div className="ShareRemind-social">
          {shareText}
          {socials}
        </div>
      </div>
    );
  }
}

export default ShareRemind;



// WEBPACK FOOTER //
// ./src/user/components/ShareRemind.jsx